module.exports = __webpack_public_path__ + "img/arrow-down-small-big.84e0cfac.svg";